import {actionSetModalParams} from 'modules/auth/slice';
import {TAppThunk} from 'core/redux/types';
import {MODALS} from 'modules/modals/constants';
import {isBrowserContext} from 'core/helpers';
import {AUTH_MODAL_FORM_TYPE} from 'modules/products/constants';
import {actionSetPortalVisible} from 'modules/portal/slice';
import {APP_ROUTES_KEYS, APP_ROUTES_TO_URL, PRIVATE_ROUTE_BASE_TO_URL} from 'core/modules/routing/constants';
import {CookieService} from 'core/services/CookieService';
import {INVALIDATE_USER_CACHE} from 'core/constants';
import {CACHE_USER_SESSION} from 'core/helpers/env';
import {consumePendingAuthContinuation, setPendingAuthContinuation} from 'modules/auth/utils/pendingAuthContinuation';
import {getUser} from 'modules/user/services';
import {IUserData} from 'modules/user/models';
import {baseApi} from 'core/redux/store/api';

export const authLogout: TAppThunk<void> = async (_dispatch, _, {authService}) => {
    await authService.authLogout();

    // устанавливаем флаг, чтобы на сервере сбросить серверный кеш пользователя по PHPSESSID
    if (CACHE_USER_SESSION) {
        CookieService.getInstance().setInsecureCookie(INVALIDATE_USER_CACHE, '1');
    }

    // await dispatch(resetAuthState);

    if (isBrowserContext()) {
        const isInsideProfile = window.location.pathname.startsWith(PRIVATE_ROUTE_BASE_TO_URL);

        if (isInsideProfile) {
            const homeUrl = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.main] || '/';
            window.location.replace(homeUrl);
        } else {
            window.location.reload();
        }
    }
};

export const showAuthDialog: TAppThunk<void> = async (dispatch) => {
    dispatch(
        actionSetModalParams({
            name: MODALS.AUTH_DIALOG.name,
            params: {
                type: AUTH_MODAL_FORM_TYPE.simple,
            },
        }),
    );

    dispatch(actionSetPortalVisible(MODALS.AUTH_DIALOG.name));
};

export const showAuthDialogWithContinuation =
    (onSuccess: (user: IUserData) => void | Promise<void>): TAppThunk<void> =>
    async (dispatch) => {
        setPendingAuthContinuation(onSuccess);
        dispatch(showAuthDialog);
    };

export const runPendingAuthContinuation = (): TAppThunk<void> => async (dispatch) => {
    const continuation = consumePendingAuthContinuation();

    if (!continuation) {
        return;
    }

    // точечно инвалидируем именно 'User' (а не весь кэш через invalidateUserDependentData) —
    // continuation должна получить свежего пользователя раньше, чем что-либо ещё сбросит
    // остальной кэш (например листинг), иначе порядок операций внутри continuation ломается
    dispatch(baseApi.util.invalidateTags(['User']));

    const {data: user} = await dispatch(getUser.initiate());

    if (user) {
        await continuation(user);
    }
};
